import { useState } from "react";
import { caxios } from "../../config/config";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../store/useAuthStore";

function useLogin() {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);

  // 입력창 빈값 확인용
  const [check, setCheck] = useState({ id: false, pw: false });

  // 로그인 버튼 클릭시 error 표시용
  const [error, setError] = useState({ id: false, pw: false });

  // 상태변수 준비
  const [id, setId] = useState(""); // 이메일
  const [pw, setPw] = useState(""); // 비밀번호

  // 아이디(이메일) 입력창 핸들러
  const hendleChangeById = (e) => {
    let value = e.target.value;
    setId(value);
    if (value !== "") {
      // 입력했을시
      setCheck((prev) => ({
        ...prev,
        id: true,
      }));
      // 입력하면 error 초기화
      setError((prev) => ({
        ...prev,
        id: false,
      }));
    } else {
      // 빈값일때
      setCheck((prev) => ({
        ...prev,
        id: false,
      }));
    }
  };

  // 비밀번호 입력창 핸들러
  const hendleChangeByPw = (e) => {
    let value = e.target.value;
    setPw(value);
    if (value !== "") {
      // 입력했을시
      setCheck((prev) => ({
        ...prev,
        pw: true,
      }));
      // 입력하면 error 초기화
      setError((prev) => ({
        ...prev,
        pw: false,
      }));
    } else {
      // 빈값일때
      setCheck((prev) => ({
        ...prev,
        pw: false,
      }));
    }
  };

  // 로그인 버튼 클릭시
  const clickLogin = () => {
    // check 상태 기반으로 모든 칸이 입력되었는지 확인
    const allvalid = Object.values(check).every((value) => value === true);

    // 입력 안한칸이 있다면 false로 중단
    if (!allvalid) {
      // error 상태 업데이트 → 빈칸이면 true
      setError({
        id: id === "",
        pw: pw === "",
      });
      return false;
    }

    //1. 토큰 분리 로직을 처리하는 헬퍼 함수 정의

    const processLoginResponse = (combinedToken) => {
      const cleanToken = combinedToken.trim();
      //  토큰을 "|||" 구분자로 분리
     // const tokenParts = cleanToken.split("|||");

     // if (tokenParts.length === 2) {
       // const generalToken = tokenParts[0].trim(); // (Token A: 일반 API용)
       // const jamesAccessToken = tokenParts[1].trim(); // (Token B: 메일 발송용)

        // 2. 각각의 sessionStorage 키에 저장
        //sessionStorage.setItem("token", generalToken);
        sessionStorage.setItem("token", cleanToken);

       // sessionStorage.setItem("jamesAccessToken", jamesAccessToken);

       // console.log("일반 토큰 (A):", generalToken);
       // console.log("메일 토큰 (B):", jamesAccessToken);
        //return cleanToken;
      //}
      // return null;
    };

    // if문 통과시 데이터 전송
    caxios
      .post("/member/login", { email: id, pw: pw }, { withCredentials: true })
      .then((resp) => {
        if (resp.data) {
          console.log("캐시오스 리턴1:", resp.data);

          // 로그인 성공시 토큰 및 id값 저장
          // const generalToken = processLoginResponse(resp.data);

          // if (resp.data) {
            login(resp.data, id);

            console.log(resp.data);

            navigate("/");
          // } else {
          //   alert("토큰 구조 오류로 로그인 실패");
          // }
        }
      })
      .catch((err) => {
        alert("로그인 실패 : 이메일 또는 비밀번호 확인 필요"); // 나중에 제거하셈
        setId("");
        setPw("");
      });
  };

  return {
    id,
    pw,
    check,
    error,
    hendleChangeById,
    hendleChangeByPw,
    clickLogin,
  };
}

export default useLogin;
